import { render, staticRenderFns } from "./HeaderMagazineDetail.vue?vue&type=template&id=691985c4&"
import script from "./HeaderMagazineDetail.vue?vue&type=script&lang=js&"
export * from "./HeaderMagazineDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports